import { dynamicImport } from '@core/helpers'
import { getCountryConfig } from '@core/helpers/countries'
import { ROUTES } from '@router'

const Product = () => dynamicImport(import('./pages/product'))

export default ({ country, config }) => {
  const useNewUrl = config.FF_NEW_URL_FORMAT.includes(country)
  const countryConfig = getCountryConfig(country)
  const merchantNameSpace = countryConfig.routesValidation.shop
  const productPageRegexs = countryConfig.routesValidation.product

  let routePath
  if (useNewUrl) {
    routePath = {
      [ROUTES.PRODUCT.MERCHANT]: '/s/:merchantName/:merchantId/p/:uuid',
      [ROUTES.PRODUCT.HOME]: '/p/:slugV2/:uuid',
    }
  } else {
    routePath = {
      [ROUTES.PRODUCT
        .MERCHANT]: `/:slug(${productPageRegexs})/${merchantNameSpace}-:merchant/:id.html`,
      [ROUTES.PRODUCT.HOME]: `/:slug(${productPageRegexs})/:id.html`,
    }
  }

  return [
    {
      name: ROUTES.PRODUCT.MERCHANT,
      path: routePath[ROUTES.PRODUCT.MERCHANT],
      component: Product,
    },
    {
      name: ROUTES.PRODUCT.HOME,
      path: routePath[ROUTES.PRODUCT.HOME],
      component: Product,
    },
  ]
}
